import OrderProduct from '../components/OrderProducts/OrderProducts'
export default function Order() {
    return (
        <div>
            <div>
                <OrderProduct/>
            </div>
        </div>
    )
}